// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"911be03d","303":"ffc416f5","441":"5aa2ea83","453":"241db705"}[chunkId] + ".chunk.js";
};